module.exports = __webpack_public_path__ + "img/cagliari-logo-icon.771971c4.png";